import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Sidebar } from 'primeng/sidebar';
import { Subscription } from 'rxjs';
import { FhSideBarProviderService } from '../helpers/providers/fh-side-bar-provider.service';
import { FhSideBarVisibleEmitterModel } from '../helpers/objects/fh-side-bar-visible-emitter/fh-side-bar-visible-emitter-model';

@Component({
  selector: 'ui-fh-side-bar',
  templateUrl: './fh-side-bar.component.html',
  styleUrl: './fh-side-bar.component.scss'
})
export class FhSideBarComponent implements OnInit, OnDestroy {
  @Input() id: string = '';
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() class?: string = '';
  @Input() icon?: string = '';
  @Input() iconClass?: string = '';
  @Input() label: string = '';
  @Input() slideLabel = false;
  @Input() sidebarPosition: 'LEFT' | 'TOP' | 'RIGHT' | 'BOTTOM' = 'LEFT';
  @Input() sidebarStyleClass: string = '';
  @Input() sidebarFullscreen: boolean = false;
  @Input() dismissable: boolean = true;
  @Input() route: string = '';
  @Input() initialRoute: string = '';
  @Input() headless: boolean = false;
  @Input() width = 'auto';
  @Output() onVisibleChangeEmitter = new EventEmitter<boolean>();

  visibleChangeSubscription: Subscription = new Subscription();
  widthChangeSubscription: Subscription = new Subscription();

  constructor(private router: Router, private fhSideBarProviderService: FhSideBarProviderService, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.backgroundEvents();
  }

  ngOnDestroy() {}

  private backgroundEvents() {
    this.visibleChangeSubscription = this.fhSideBarProviderService.visibleChangedEmitter.subscribe({
      next: (response: FhSideBarVisibleEmitterModel) => {
        if (this.id == response.id) {
          this.visible = !this.visible;
        }

        if (response.route) {
          this.router.navigate(this.setRouteAndOutlet(response.route));
        } else if (this.initialRoute != '') {
          this.router.navigate(this.setRouteAndOutlet(this.initialRoute));
        }
      }
    });
    this.widthChangeSubscription = this.fhSideBarProviderService.widthChangedEmitter.subscribe({
      next: (value: string) => {
        this.width = value;
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  setRouteAndOutlet(url: string | null) {
    let json: any;

    json = [{ outlets: {} }];

    if (url === null) {
      json[0].outlets[this.route] = null;
    } else {
      json[0].outlets[this.route] = url.split('/');
    }

    return json;
  }

  onVisibleChange(sideBar: Sidebar) {
    if (!this.visible) {
      this.onVisibleChangeEmitter.emit(this.visible);
      this.router.navigate(this.setRouteAndOutlet(null));
    }
    this.visibleChange.emit(this.visible);
  }

  onHide(){
    this.visibleChange.emit(false)
  }
}
